import { istYYMMDD } from './ist'

/**
 * Human codes minted on the phone. The per-device counter comes from
 * offline/meta.ts#nextDailyCounter so a counter value is never reused.
 */

/** CS-{YYMMDD}-{village}-{device prefix}-{nn}, e.g. CS-261018-BELU-A1-01. */
export function sessionCode(args: {
  villageCode: string
  devicePrefix: string
  counter: number
  at?: Date | number
}): string {
  const nn = String(args.counter).padStart(2, '0')
  return `CS-${istYYMMDD(args.at ?? Date.now())}-${args.villageCode.trim().toUpperCase()}-${args.devicePrefix.trim().toUpperCase()}-${nn}`
}

export const VILLAGE_CODE_RE = /^[A-Z0-9]{2,20}$/
export const DEVICE_PREFIX_RE = /^[A-Z0-9]{1,4}$/
export const SESSION_CODE_RE = /^CS-\d{6}-[A-Z0-9]{2,20}-[A-Z0-9]{1,4}-\d{2,3}$/

/**
 * QR payloads end in `{state}-{village}-{B|L|S}{sequence}` (B bag tag, L seal strip, S before
 * the kind letter existed). Reading the village from an issued roll
 * lets an offline phone repair an older registration that was saved before the village QR code
 * existed on the server.
 */
export function villageCodeFromQrPayload(payload: string): string | null {
  const parts = payload.trim().toUpperCase().split('-')
  if (parts.length < 3 || !/^[BLS][A-Z]+\d{3}$/.test(parts.at(-1) ?? '')) return null
  const village = parts.at(-2) ?? ''
  return VILLAGE_CODE_RE.test(village) ? village : null
}

/** Return the one village represented by the payloads, never guess across mixed rolls. */
export function villageCodeFromQrPayloads(payloads: readonly string[]): string | null {
  const villages = new Set(payloads.map(villageCodeFromQrPayload).filter((v): v is string => !!v))
  return villages.size === 1 ? [...villages][0]! : null
}
